import { Menu } from '../models/menu.model';

/**
 * Navegacion por intencion, no por pantalla heredada: cada entrada responde una
 * pregunta del programa NPS y el detalle vive en pestañas dentro de la seccion.
 */
export const MENU: Array<Menu> = [
  { icon: 'bi-activity',         route: '/pulso',    title: 'Pulso' },
  { icon: 'bi-compass',          route: '/explorar', title: 'Explorar' },
  { icon: 'bi-chat-quote',       route: '/voz',      title: 'Voz del cliente' },
  { icon: 'bi-lightning-charge', route: '/acciones', title: 'Acciones' },
  { icon: 'bi-heart-pulse',      route: '/programa', title: 'Programa' },
];

/** Subtitulo de cada seccion: la pregunta que responde. */
export const MENU_HINTS: Record<string, string> = {
  '/pulso':    '¿Cómo vamos?',
  '/explorar': '¿Dónde está el problema?',
  '/voz':      '¿Por qué?',
  '/acciones': '¿Qué hacemos?',
  '/programa': '¿El programa está sano?',
};
